import Glider from 'glider-js';

(function () {
	const carousels = document.querySelectorAll('.js-carousel.glider');

	// TKR-DS-001: client-side tag of the GAM4 tracking attrs on every card
	// anchor inside a `.block-carousel` track. Card content is editor-authored
	// (core blocks) and not visible to PHP, so we inject the attrs on load.
	// Skipped when an anchor already declares `data-element` so existing
	// per-block tracking is never overridden.
	const tagBlockCarouselAnchors = (carousel) => {
		if (!carousel.classList.contains('block-carousel')) return;
		const slides = carousel.querySelectorAll('.glider-track > *');
		const pageUrl = window.location.origin + window.location.pathname;
		slides.forEach((slide, index) => {
			const anchors = slide.querySelectorAll('a[href]');
			anchors.forEach((a) => {
				if (a.hasAttribute('data-element')) return;
				a.setAttribute('data-element', 'article_click');
				a.setAttribute('data-placement', 'block_carousel');
				a.setAttribute('data-position', String(index + 1));
				a.setAttribute('data-page-url', pageUrl);
				const name = (a.textContent || '').trim().slice(0, 120) || a.getAttribute('title') || '';
				if (name) a.setAttribute('data-name', name);
			});
		});
	};

	for (const carousel of carousels) {
		const track = carousel.querySelector('.glider-track');
		const hasSlides = track && track.children.length > 0;
		if (!hasSlides) continue;
		tagBlockCarouselAnchors(carousel);
		new Glider(carousel, {
			slidesToShow: 'auto',
			dragVelocity: 1.5,
			draggable: true,
			skipTrack: true,
		});
	}
})();
